import axios from 'axios';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { modalChannels } from '../constants/UtilVariables';

const isLoggedIn = Page.isLoggedIn();

function requestPostChatBotEligibilityAPI() {
  return {
    type: types.REQUEST_POST_CHATBOT_ELIGIBILITY,
  };
}

function postChatBotEligibilityResponse(responseData) {
  return {
    type: types.POST_CHATBOT_ELIGIBILITY_RESPONSE,
    payload: responseData && responseData.chatBotInfo,
  };
}

function postChatBotEligibilityError() {
  return {
    type: types.POST_CHATBOT_ELIGIBILITY_ERROR,
  };
}

export function postChatBotEligibleFalse() {
  return {
    type: types.POST_CHATBOT_ELIGIBILITY_FALSE,
  };
}

function mmtCheckResponse(mmtResponse) {
  return {
    type: types.MMT_CHECK_RESPONSE,
    payload: mmtResponse,
  };
}
/**
 * calling post-chat-bot-eligibility API
 */
export function postChatBotEligibility(options) {
  const optionsBody = options.postChatBotResponse ? options.postChatBotResponse : options;
  return (dispatch, getState) => {
    // don't need to check in email pages
    if (Page.getLogoutEmailRefId()) {
      return null;
    }
    const state = getState();
    // Get topic from smcResultKeeper if locale is not changed.
    // If locale is changed get the topic from modal.
    const topic = ((state || {}).smcResultKeeper || {}).topicTreeSelectResult || ((state || {}).modal || {}).topic;
    const channel = modalChannels.chatBot;
    const { intentId, intentType, entryPoint } = optionsBody;
    dispatch(requestPostChatBotEligibilityAPI());

    const URL = `/smarthelp/post-chat-bot-eligibility?intentId=${intentId}&intentType=${intentType}&entryPoint=${entryPoint}`;
    return axios
      .get(URL)
      .then((response) => {
        dispatch(postChatBotEligibilityResponse(response.data));
        // if user is logged in & API returns eligible, chatBotDisplay returns true
        const chatBotDisplay =
          isLoggedIn && response.data && response.data.chatBotInfo && response.data.chatBotInfo.result === 'ELIGIBLE';
        /**
         * if user is loggedIn by clicking on the chatBot
         * showChat callback is for opening the chat
         * reject callback is for opening the chatBotIneligible Modal
         */
        if (chatBotDisplay && typeof options.showChat === 'function') {
          dispatch(options.showChat(topic, channel, options.origin));
        } else if (!chatBotDisplay && typeof options.reject === 'function') {
          dispatch(options.reject());
        }
      })
      .catch(() => {
        dispatch(postChatBotEligibilityError());
        /**
         * if user is loggedIn by clicking on the chatBot and
         * if API returns error return reject callback which opens chatBotIneligible Modal
         */
        if (isLoggedIn && typeof options.reject === 'function') {
          dispatch(options.reject());
        }
      });
  };
}

export function mmtCheck() {
  return (dispatch) => {
    const requestURL = '/smarthelp/mmt-async-check';
    return axios
      .get(requestURL)
      .then((response) => {
        const conversations = response && response.data && response.data.conversations;
        if (conversations && conversations.length) {
          dispatch(mmtCheckResponse({ isConversationActive: true, id: conversations[0].id, serviceError: false }));
        } else {
          dispatch(mmtCheckResponse({ isConversationActive: false, serviceError: false }));
        }
      })
      .catch(() => {
        dispatch(mmtCheckResponse({ isConversationActive: false, serviceError: true }));
      });
  };
}

export const exportedForTesting = {
  requestPostChatBotEligibilityAPI,
  postChatBotEligibilityResponse,
  postChatBotEligibilityError,
  mmtCheckResponse,
};
